<template>
  <div class="examRecord">
    <usertop></usertop>
    <!-- <div class="user_bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/userindex' }"
          >考试任务</el-breadcrumb-item
        >
        <el-breadcrumb-item>开始考试</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="recordView">
      <div class="recordViewLf">
        <div class="recordViewTop">
          <h1>{{ title }}</h1>
          <label
            ><span>姓名：{{ username }}</span
            ><span>工号：</span></label
          >
          <label
            ><span>试卷总分：{{ scores }}分</span
            ><span>及格分数：{{ score }}分</span
            ><span>考试时间：{{ time }}</span></label
          >
        </div>
        <div class="recordViewCom">
          <div
            class="recordViewtest"
            v-for="(item, idx) in titleList"
            :key="idx"
          >
            <div class="recordtestlf lf">
              <h1 v-if="item.q_type != 3">
                {{ idx + 1 }}.【{{ item.q_type | judgeLX }}】{{
                  item.questions
                }}({{ item.scores }}分)
              </h1>
              <h1 v-else class="titleh" ref="titletop">
                {{ idx + 1 }}.【{{ item.q_type | judgeLX }}】<span></span>({{
                  item.scores
                }}分)
              </h1>
              <el-checkbox-group
                v-model="recordexam[idx]"
                v-if="item.q_type == 5"
              >
                <el-checkbox
                  v-for="(a, ix) in item.answer"
                  :key="ix"
                  :label="ix"
                  >{{ answerList[ix] }}.{{ a }}</el-checkbox
                >
              </el-checkbox-group>
              <el-radio-group
                v-model="recordexam[idx]"
                v-else-if="item.q_type == 1 || item.q_type == 2"
              >
                <el-radio
                  v-for="(r, diao) in item.answer"
                  :key="diao"
                  :label="diao"
                  >{{ answerList[diao] }}.{{ r }}</el-radio
                >
              </el-radio-group>
              <el-input
                type="textarea"
                :rows="6"
                placeholder="请输入内容"
                v-else-if="item.q_type == 4"
                resize="none"
                show-word-limit
                v-model="recordexam[idx]"
              >
              </el-input>
            </div>
          </div>
        </div>
        <div class="btn_up">
          <el-button
            type="primary"
            @click="updateLoad"
            :disabled="disablednum == 1 ? true : false"
            >提交</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title="选择课件"
      :visible.sync="openCourseware"
      custom-class="dialogFw dialoAns"
    >
      <div class="ViewDialog_Ans">
        <img src="/static/img/pass.png" v-if="examresult == '及格'" />
        <img src="/static/img/over.png" v-else-if="examresult == '满分'" />
        <img src="/static/img/fail.png" v-else />
        <div class="Ans_score">
          <span
            >您的得分：<b>{{ results }}</b></span
          >
          <p>交卷时间：{{ restime }}</p>

          <router-link :to="{ path: '/parseTest', query: { id: id, atid } }">
            查看答案解析
          </router-link>
        </div>
      </div>
      <div class="ViewDialog_Up">
        <!-- <el-button @click="Uptree">确定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import usertop from "@/components/user/userTop";
export default {
  name: "examTest",
  data() {
    return {
      recordexam: {},
      answerradio: "",
      titleList: [],
      answerList: ["A", "B", "C", "D", "E", "F", "G"],
      subList: [],
      inputList: [],
      title: "",
      username: "",
      time: "",
      openCourseware: false,
      results: "",
      disablenum: 0,
      restime: "",
      examresult: "",
      scores: "",
      id: this.$route.query.id,
      rexam: this.$route.query.rexam,
      score: "",
      wid: "",
      aid: "",
      atid: "",
    };
  },
  filters: {
    judgeLX: function (value) {
      var returnValue = "";
      var val = parseInt(value);
      switch (val) {
        case 1:
          returnValue = "单选题";
          break;
        case 2:
          returnValue = "判断题";
          break;
        case 3:
          returnValue = "填空题";
          break;
        case 4:
          returnValue = "简答题";
          break;
        case 5:
          returnValue = "多选题";
          break;
      }
      return returnValue;
    },
  },
  components: {
    usertop,
  },
  methods: {
    updateLoad() {
      var list = [];
      for (let x in this.titleList) {
        if (this.titleList[x].q_type == 3) {
          var text = "";
          var ntext = "";
          $(".recordtestlf")
            .eq(x)
            .find("input")
            .each(function (i, ix) {
              if ($(this).val() == "") {
                text += "null|";
              } else {
                text += $(this).val() + "|";
              }
            });
          list.push({ ans: text.substring(0, text.length - 1) });
        } else if (this.titleList[x].q_type == 5) {
          list.push({ ans: this.recordexam[x].join("|") });
        } else {
          list.push({ ans: this.recordexam[x] });
        }
        list[x]["id"] = this.titleList[x].q_id;
      }
      // for (let n in list){
      //     if(list[n].ans===''){
      //         this.alertView.failView('第'+(parseInt(n)+1)+'题不能为空')
      //         return false
      //     }
      // }

      // 考试
      if (this.rexam == "undefined") {
        var data = {
          service: "ExamtaskXt.ExamMarking",
          tid: this.id,
          userid: localStorage.getItem("userid"),
          answers: JSON.stringify(list),
          aid: this.aid,
          wid: this.wid,
        };
      } else {
        // 重考
        var data = {
          service: "ExamtaskXt.ExamMarking",
          tid: this.id,
          userid: localStorage.getItem("userid"),
          answers: JSON.stringify(list),
          num: this.rexam,
          aid: this.aid,
          wid: this.wid,
        };
      }
      var jsondata = JSON.stringify(data);

      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        const { code, msg } = { ...res.data.data };
        if (code) return this.$message.error(msg);

        const { atid } = { ...res.data.data };
        this.alertView.successView("数据提交成功");
        this.openCourseware = true;
        this.results = res.data.data.results;
        this.restime = res.data.data.time;
        this.examresult = res.data.data.pass;
        this.atid = atid;
      });
    },
    Uptree() {
      // this.$router.push({ path: "/userindex" });
    },
  },
  mounted() {
    this.wid = this.$route.query.wid;
    this.aid = this.$route.query.aid;
    var data = {
        service: "ExamtaskXt.Exam",
        tid: this.id,
        userid: localStorage.getItem("userid"),
        wid: this.wid,
        aid: this.aid,
      },
      list = [],
      listIx = [],
      sub = [];
    var reg = [];
    this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
      console.log(res);
      const { code, msg } = { ...res.data.data };
      if (code) return this.$message.error(msg);
      this.title = res.data.data.title;
      this.username =
        res.data.data.username || localStorage.getItem("username");
      this.time = res.data.data.time;
      this.scores = res.data.data.scores;
      this.score = res.data.data.score;
      for (var i = 0; i < res.data.data.qsn.length; i++) {
        list.push(res.data.data.qsn[i]);
        if (res.data.data.qsn[i].q_type == 3) {
          reg.push(
            res.data.data.qsn[i].questions.replace(
              /\([^\)]*\)/g,
              '<input type="text" class="inputtext">'
            )
          );
        }
        listIx.push(res.data.data.qsn[i].subanswer);
      }
      for (let n in res.data.data.sub) {
        sub.push(res.data.data.sub[n]);
      }
      this.titleList = list;
      this.subList = sub;
      listIx = listIx.map(Number);
      for (let key in this.titleList) {
        if (
          this.titleList[key].q_type == 1 ||
          this.titleList[key].q_type == 2 ||
          this.titleList[key].q_type == 4
        ) {
          this.$set(this.recordexam, key, "");
        } else if (this.titleList[key].q_type == 5) {
          this.$set(this.recordexam, key, []);
        }
      }
      this.$nextTick(() => {
        for (let n in $(".titleh")) {
          $(".titleh").eq(n).find("span").html(reg[n]);
        }
      });
    });
  },
};
</script>
<style>
@import "../../../assets/css/user.css";
@import "../../../assets/css/task.css";
</style>


// WEBPACK FOOTER //
// src/components/scholl/examTest/examTest.vue